import { classNames } from '@/utils/helpers'

interface Props extends React.PropsWithChildren {
  title: string
  description: string
  actions: React.ReactNode
  className?: string
}

export const QuestionnaireStep = ({
  title,
  description,
  actions,
  children,
  className,
}: Props) => {
  return (
    <div className="relative z-10">
      <div className="space-y-2">
        <h2 className="text-2xl font-semibold leading-9">{title}</h2>
        <p className="leading-[26px] text-secondary-300">{description}</p>
      </div>
      <div className={classNames('mt-8', className)}>{children}</div>
      <div className="mt-12 flex items-center justify-between">{actions}</div>
    </div>
  )
}
